export default __webpack_public_path__ + "static/media/greeter-dapp.70de480a.png";